export default function checkLogin() {
  return localStorage.getItem('nms_userStatus') === 'login';
}